<template>
    <div v-if="showFullScreenBtn"
        class="full-screen-btn-con"
        @click="handleChange">
        <Tooltip :content="value ? '退出全屏' : '全屏'"
            placement="bottom">
            <Icon :type="value ? 'md-contract' : 'md-expand'"
                :size="23"></Icon>
        </Tooltip>
    </div>
</template>
<script>
export default {
    name: 'Fullscreen',
    computed: {
        showFullScreenBtn() {
            return window.navigator.userAgent.indexOf('MSIE') < 0
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleFullscreen() {
            let main = document.body

            if (this.value) {
                if (main.requestFullscreen) {
                    main.requestFullscreen()
                } else if (main.mozRequestFullScreen) {
                    main.mozRequestFullScreen()
                } else if (main.webkitRequestFullScreen) {
                    main.webkitRequestFullScreen()
                } else if (main.msRequestFullscreen) {
                    main.msRequestFullscreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            }
        },
        handleChange() {
            this.$emit("input", !this.value)
        },
    },

    watch: {
        value(val) {
            this.handleFullscreen()
        },
    },

    mounted() {
        let isFullscreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen

        isFullscreen = !!isFullscreen
        
        this.$emit('input', isFullscreen)
    }
}

</script>
<style lang="less">
.full-screen-btn-con .ivu-tooltip-rel {
    height: 64px;
    line-height: 56px;

    i {
        cursor: pointer;
    }
}

</style>
